import React, { Component } from "react";
import moment from "moment-timezone";
import { languages } from "../../constants/languages";
import FieldsContainer from "../../containers/schedule/FieldsContainer";
import { withTheme } from "@material-ui/core/styles";
import SportParksContainer from "./SportParksContainer";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import TimeSlidersContainer from "../../containers/schedule/TimeSlidersContainer";
import ExportContainer from "../results/ExportContainer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

class DaysContainer extends Component {
  state = {
    open: false,
    anchorEl: null,
  };

  selectDay = (dayId) => {
    this.props.selectDay(dayId);
    this.handleClose();
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    return (
      <div>
        <div
          style={{
            display: "flex",
            borderBottom: this.props.resultsPage
              ? ""
              : "1px solid rgba(0, 0, 0, 0.12)",
            paddingBottom: 10
          }}
        >
          <Menu
            id="menu-days"
            anchorEl={this.state.anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            getContentAnchorEl={null}
            open={Boolean(this.state.anchorEl)}
            onClose={this.handleClose}
          >
            <MenuItem
              selected={this.props.selectedDay === "0"}
              onClick={(e) => this.selectDay("0")}
            >
              {moment
                .unix(this.props.tournament.date)
                .format(languages.createTournament.dateFormat)}
            </MenuItem>
            {this.props.days
              .sort((a, b) => a.date - b.date)
              .map((day) => (
                <MenuItem
                  key={day.id}
                  selected={this.props.selectedDay === day.id}
                  onClick={(e) => this.selectDay(day.id)}
                  style={{ paddingRight: 50 }}
                >
                  {moment
                    .unix(day.date)
                    .format(languages.createTournament.dateFormat)}
                </MenuItem>
              ))}
          </Menu>
          {this.props.days.length > 0 && (
              <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={this.handleMenu}
                style={{ marginRight: 10, whiteSpace: "nowrap" }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                {this.props.selectedDay === "0"
                  ? moment
                      .unix(this.props.tournament.date)
                      .format(languages.createTournament.dateFormat)
                  : moment
                      .unix(
                        (this.props.daysByKey[this.props.selectedDay] || {})
                          .date
                      )
                      .format(languages.createTournament.dateFormat)}
              </Button>
          )}
          <SportParksContainer
            tournament={this.props.tournament}
            {...this.props}
          />
          <div style={{ flex: "1 1 10%" }} />
          {!this.props.resultsPage && (
            <div style={{ display: "flex" }}>
              <div style={{ marginRight: 10 }}>
                <TimeSlidersContainer
                  tournament={this.props.tournament}
                  divisions={this.props.divisions}
                  poules={this.props.pouleOptions}
                  brackets={this.props.bracketOptions}
                  daysByKey={this.props.daysByKey}
                  poulesByKey={this.props.poulesByKey}
                />
              </div>
              <ExportContainer
                tournament={this.props.tournament}
                matches={this.props.matches}
                matchesPerDay={this.props.matchesPerDay}
                daysByKey={this.props.daysByKey}
                poules={this.props.allPoules}
                poulesByKey={this.props.poulesByKey}
                brackets={this.props.brackets}
                bracketsByKey={this.props.bracketsByKey}
                refereesByKey={this.props.refereesByKey}
                divisionsObject={this.props.divisionsObject}
                resultSpots={this.props.resultSpotsAll}
                sportParks={this.props.sportParks}
                sportParksByKey={this.props.sportParksByKey}
                userData={this.props.userData}
                schedulePage
                players={this.props.players}
              />
              <div style={{ padding: 2 }}>
                <IconButton
                  onClick={this.props.handleSideSheetExpandClick}
                  style={{
                    height: 28,
                    width: 28,
                    marginLeft: 8,
                    marginRight: 8,
                  }}
                >
                  <MenuIcon
                    style={{
                      height: 20,
                      width: 20,
                      position: "absolute",
                      top: 4,
                    }}
                  />
                </IconButton>
              </div>
            </div>
          )}
        </div>

        {!this.props.resultsPage && (
          <FieldsContainer
            {...this.props}
            day={this.props.selectedDay}
            selectedSportPark={this.props.selectedSportPark}
          />
        )}
      </div>
    );
  }
}

export default withTheme(DaysContainer);
